"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockAuthContextState = void 0;
exports.mockUserSettingOptions = mockUserSettingOptions;
exports.mockUserLevelSettings = mockUserLevelSettings;
exports.mockUser = mockUser;
exports.mockProduct = mockProduct;
exports.mockAffirmProduct = mockAffirmProduct;
exports.mockInSyncProduct = mockInSyncProduct;
exports.mockEquipProduct = mockEquipProduct;
exports.mockInklingProduct = mockInklingProduct;
exports.mockClass = mockClass;
exports.mockAssessmentTemplate = mockAssessmentTemplate;
exports.mockAssessmentTemplateEmtx = mockAssessmentTemplateEmtx;
exports.mockAssessment = mockAssessment;
exports.mockAgsAssessment = mockAgsAssessment;
exports.mockAttempt = mockAttempt;
exports.mockAttemptRubricSelection = mockAttemptRubricSelection;
exports.mockAssignment = mockAssignment;
exports.mockItem = mockItem;
exports.mockItemEMTX = mockItemEMTX;
exports.mockQuestion = mockQuestion;
exports.mockStimulus = mockStimulus;
exports.mockCurriculum = mockCurriculum;
exports.mockEurekaMathCurriculum = mockEurekaMathCurriculum;
exports.mockEurekaMathTXCurriculum = mockEurekaMathTXCurriculum;
exports.mockWitAndWisdomCurriculum = mockWitAndWisdomCurriculum;
exports.mockGrade = mockGrade;
exports.mockModule = mockModule;
exports.mockLesson = mockLesson;
exports.mockTopic = mockTopic;
exports.mockItemResponse = mockItemResponse;
exports.mockQuestionResponse = mockQuestionResponse;
exports.mockFeedback = mockFeedback;
exports.mockPerformanceBand = mockPerformanceBand;
exports.mockPerformanceBandEmtx = mockPerformanceBandEmtx;
exports.mockSettingsPerformanceBand = mockSettingsPerformanceBand;
exports.mockItemPerformance = mockItemPerformance;
exports.mockAssessmentPerformanceBandDistribution = mockAssessmentPerformanceBandDistribution;
exports.mockPlayerOptions = mockPlayerOptions;
exports.mockScoreOptions = mockScoreOptions;
exports.mockReportingOptions = mockReportingOptions;
exports.mockAssessmentTypeOptions = mockAssessmentTypeOptions;
exports.mockStandardsOptions = mockStandardsOptions;
exports.mockStandardSet = mockStandardSet;
exports.mockOption = mockOption;
exports.mockAdminOption = mockAdminOption;
exports.mockSettingOptions = mockSettingOptions;
exports.mockAdminSettingOptions = mockAdminSettingOptions;
exports.mockWWSettingOptions = mockWWSettingOptions;
exports.mockAssigneePerformance = mockAssigneePerformance;
exports.mockAssigneePerformanceWW = mockAssigneePerformanceWW;
exports.mockClassPerformance = mockClassPerformance;
exports.mockAssigneeStandardPerformance = mockAssigneeStandardPerformance;
exports.mockAssigneeStandardPerformanceEmtx = mockAssigneeStandardPerformanceEmtx;
exports.mockStandardPerformance = mockStandardPerformance;
exports.mockSkippedItemResponse = mockSkippedItemResponse;
exports.mockStandardPerformanceBandDistribution = mockStandardPerformanceBandDistribution;
exports.mockPerformanceBandDistribution = mockPerformanceBandDistribution;
exports.mockOverallStandardPerformance = mockOverallStandardPerformance;
exports.mockAssessmentCompletionSummary = mockAssessmentCompletionSummary;
exports.mockReopenAssessmentCount = mockReopenAssessmentCount;
exports.mockAssessmentPerformanceInfo = mockAssessmentPerformanceInfo;
exports.mockAssessmentPerformance = mockAssessmentPerformance;
exports.mockAssessmentPerformanceWW = mockAssessmentPerformanceWW;
exports.mockDomain = mockDomain;
exports.mockParentDomain = mockParentDomain;
exports.mockCluster = mockCluster;
exports.mockParentCluster = mockParentCluster;
exports.mockStandard = mockStandard;
exports.mockStandardItem = mockStandardItem;
exports.mockStandardItemEmtx = mockStandardItemEmtx;
exports.mockChildStandard = mockChildStandard;
exports.mockItemStandard = mockItemStandard;
exports.mockItemStandardEmtx = mockItemStandardEmtx;
exports.mockAssessmentTemplateItemStandard = mockAssessmentTemplateItemStandard;
exports.mockAssessmentTemplateItemStandardEmtx = mockAssessmentTemplateItemStandardEmtx;
exports.mockLogout = mockLogout;
exports.mockImpersonate = mockImpersonate;
exports.mockRoles = mockRoles;
exports.mockItemQuestionPerformance = mockItemQuestionPerformance;
exports.mockItemWordPerformance = mockItemWordPerformance;
exports.mockClassPerformanceWW = mockClassPerformanceWW;
exports.mockAnswer = mockAnswer;
exports.mockAssessmentClassPerformance = mockAssessmentClassPerformance;
exports.mockAnswerOption = mockAnswerOption;
exports.mockMultipleChoiceQuestion = mockMultipleChoiceQuestion;
exports.mockStudentAssessmentPerformance = mockStudentAssessmentPerformance;
exports.mockOverallStudentAssessmentPerformance = mockOverallStudentAssessmentPerformance;
exports.mockAssigneeAssessmentPerformance = mockAssigneeAssessmentPerformance;
exports.mockGoogleAnalyticsConfiguration = mockGoogleAnalyticsConfiguration;
exports.mockAnalyticsConfiguration = mockAnalyticsConfiguration;
exports.mockConfiguration = mockConfiguration;
exports.mockQuestionRubricResponse = mockQuestionRubricResponse;
exports.mockQuestionRubricResponses = mockQuestionRubricResponses;
exports.mockQuestionRubric = mockQuestionRubric;
exports.mockAssessmentTemplateUsage = mockAssessmentTemplateUsage;
exports.mockLicense = mockLicense;
exports.mockRecommendation = mockRecommendation;
exports.mockFoundational = mockFoundational;
exports.mockStudentAssignment = mockStudentAssignment;
exports.mockUserAssignment = mockUserAssignment;
exports.mockRubricCriteriaPerformance = mockRubricCriteriaPerformance;
exports.mockRubricRating = mockRubricRating;
exports.mockRubricCriteria = mockRubricCriteria;
exports.mockAssigneeRubricPerformance = mockAssigneeRubricPerformance;
exports.mockSchool = mockSchool;
exports.mockAdminSearchTemplate = mockAdminSearchTemplate;
exports.mockCurriculumAndProduct = mockCurriculumAndProduct;
exports.mockSchoolYear = mockSchoolYear;
exports.mockToken = mockToken;
exports.mockStandardsByHierarchy = mockStandardsByHierarchy;
exports.mockDistrictStaff = mockDistrictStaff;
exports.mockAdminAssessmentList = mockAdminAssessmentList;
exports.mockAverageScoreSchoolAvr = mockAverageScoreSchoolAvr;
exports.mockAverageScoreClassAvr = mockAverageScoreClassAvr;
exports.mockAvrStandardAverageScore = mockAvrStandardAverageScore;
exports.mockAvrStandarddistributions = mockAvrStandarddistributions;
exports.mockStudentDistributionAvr = mockStudentDistributionAvr;
exports.mockStudentDistributionClassAvr = mockStudentDistributionClassAvr;
exports.mockScoreByItemClassAvr = mockScoreByItemClassAvr;
exports.mockAverageSummaryAvr = mockAverageSummaryAvr;
exports.mockScoreRawItemClass = mockScoreRawItemClass;
exports.mockScoreRawItemAvr = mockScoreRawItemAvr;
exports.mockFindScoreByItemAvr = mockFindScoreByItemAvr;
exports.mockFindScoreByItemClassAvr = mockFindScoreByItemClassAvr;
exports.mockStudentItemPerformance = mockStudentItemPerformance;
exports.mockLicensesEM2 = mockLicensesEM2;
exports.mockItemCustomRubric = mockItemCustomRubric;
exports.mockCustomRubric = mockCustomRubric;
exports.mockRubric = mockRubric;
exports.mockCategory = mockCategory;
exports.mockCriterion = mockCriterion;
exports.mockRating = mockRating;
var merge_1 = __importDefault(require("lodash/merge"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var dp_acma_dawn_sdk_1 = require("@greatmindsorg/dp-acma-dawn-sdk");
var dp_testing_lib_1 = require("@greatmindsorg/dp-testing-lib");
var Auth_1 = require("../../../modules/Auth");
var constants_1 = require("../../constants");
var user_model_1 = require("../user.model");
var class_model_1 = require("../class.model");
var assessment_template_model_1 = require("../assessment-template.model");
var assessment_model_1 = require("../assessment.model");
var ags_assessment_model_1 = require("../ags-assessment.model");
var attempt_model_1 = require("../attempt.model");
var question_model_1 = require("../question.model");
var curriculum_1 = require("../curriculum");
var assignment_model_1 = require("../assignment.model");
var item_model_1 = require("../item.model");
var item_response_1 = require("../item-response");
var question_response_1 = require("../question-response");
var feedback_model_1 = require("../feedback.model");
var logout_model_1 = require("../logout.model");
var answer_option_model_1 = require("../answer-option.model");
var stimulus_model_1 = require("../stimulus.model");
var role_model_1 = require("../role.model");
var standards_1 = require("../standards");
var multiple_choice_question_model_1 = require("../multiple-choice-question.model");
var assessment_template_usage_model_1 = require("../assessment-template-usage.model");
var school_model_1 = require("../school.model");
var item_performance_model_1 = require("../performance/item-performance.model");
var assessment_performance_ww_model_1 = require("../performance/assessment-performance-ww.model");
var assessment_performance_band_distribution_model_1 = require("../performance/assessment-performance-band-distribution.model");
var assignee_performance_model_1 = require("../performance/assignee-performance.model");
var assignee_performance_ww_model_1 = require("../performance/assignee-performance-ww.model");
var class_performance_model_1 = require("../performance/class-performance.model");
var item_question_performance_model_1 = require("../performance/item-question-performance.model");
var answer_model_1 = require("../performance/answer.model");
var class_performance_ww_model_1 = require("../performance/class-performance-ww.model");
var assessment_performance_model_1 = require("../performance/assessment-performance.model");
var assignee_assessment_performance_model_1 = require("../performance/assignee-assessment-performance.model");
var rubric_criteria_performance_model_1 = require("../performance/rubric-criteria-performance.model");
var assignee_rubric_performance_model_1 = require("../performance/assignee-rubric-performance.model");
var setting_options_model_1 = require("../settings/setting-options.model");
var option_model_1 = require("../settings/option.model");
var player_options_model_1 = require("../settings/player-options.model");
var score_options_model_1 = require("../settings/score-options.model");
var standards_options_model_1 = require("../settings/standards-options.model");
var reporting_options_model_1 = require("../settings/reporting-options.model");
var assessment_type_options_model_1 = require("../settings/assessment-type-options.model");
var standard_set_model_1 = require("../settings/standard-set.model");
var settings_performance_band_model_1 = require("../settings/settings-performance-band.model");
var standard_performance_band_distribution_model_1 = require("../reports/performance/standard-performance-band-distribution.model");
var student_assessment_performance_model_1 = require("../reports/performance/student-assessment-performance.model");
var assessment_completion_summary_model_1 = require("../reports/summary/assessment-completion-summary.model");
var assessment_class_performance_model_1 = require("../reports/performance/assessment-class-performance.model");
var overall_student_assessment_performance_model_1 = require("../reports/performance/overall-student-assessment-performance.model");
var recommendation_model_1 = require("../reports/recommendation/recommendation.model");
var user_assignment_model_1 = require("../userAssignment/user-assignment.model");
var assignment_model_2 = require("../userAssignment/assignment.model");
var __1 = require("..");
var configuration_1 = require("../configuration");
var question_rubric_model_1 = require("../question-rubric.model");
var license_model_1 = require("../license.model");
var product_model_1 = require("../product.model");
var user_setting_options_model_1 = require("../user-setting-options.model");
var user_level_settings_model_1 = require("../user-level-settings.model");
var item_word_performance_model_1 = require("../performance/item-word-performance.model");
var admin_search_template_model_1 = require("../admin-search-template.model");
var curriculum_product_model_1 = require("../curriculum/curriculum-product.model");
var admin_assessment_list_model_1 = require("../admin-assessment-list.model");
var average_score_school_avr_model_1 = require("../average-score-school-avr.model");
var average_summary_avr_model_1 = require("../average-summary-avr.model");
var student_distribution_avr_model_1 = require("../student-distribution-avr.model");
var __2 = require("../..");
var reports_1 = require("../reports");
var student_item_performance_model_1 = require("../student-item-performance.model");
function mockUserSettingOptions(data) {
    if (data === void 0) { data = {}; }
    return new user_setting_options_model_1.UserSettingOptions((0, merge_1.default)({
        accessibility: {
            textToSpeech: false,
        },
    }, data));
}
function mockUserLevelSettings(data) {
    if (data === void 0) { data = {}; }
    return new user_level_settings_model_1.UserLevelSettings((0, merge_1.default)({
        userId: 'some-user-level-setting-user-id',
        type: 'some-user-level-setting-type',
        options: mockUserSettingOptions(),
    }, data));
}
function mockUser(data) {
    if (data === void 0) { data = {}; }
    return new user_model_1.User((0, merge_1.default)({
        id: '1234',
        archived: false,
        firstName: 'Ric',
        lastName: 'Black',
        roles: [constants_1.UserRole.Teacher],
        avatar: '0001',
        school: {
            id: 'any-school-id',
            name: 'School Nme',
        },
        userId: 'user-id',
        globalId: '1234',
    }, data));
}
function mockProduct(data) {
    if (data === void 0) { data = {}; }
    return new product_model_1.Product((0, merge_1.default)({
        id: 'any-id',
        name: 'any-name',
    }, data));
}
function mockAffirmProduct() {
    return mockProduct({
        id: constants_1.ProductId.Affirm,
        name: 'Affirm',
    });
}
function mockInSyncProduct() {
    return mockProduct({
        id: constants_1.ProductId.InSync,
        name: 'In Sync',
    });
}
function mockEquipProduct() {
    return mockProduct({
        id: constants_1.ProductId.Equip,
        name: 'Equip',
    });
}
function mockInklingProduct() {
    return mockProduct({
        id: constants_1.ProductId.Inkling,
        name: 'Inkling',
    });
}
function mockClass(data) {
    if (data === void 0) { data = {}; }
    return new class_model_1.Class((0, merge_1.default)({
        id: 'any-id',
        name: 'any-name',
        owner: mockUser({ id: 'any-user-id' }),
        teachers: [mockUser({ id: 'any-user-id' })],
        school: { id: 'any-school-id', name: 'My School' },
        totalStudents: 10,
        primaryTeacher: mockUser({
            id: 'any-user-id',
            firstName: 'Any Name',
            lastName: 'Any LastName',
        }),
    }, data));
}
function mockAssessmentTemplate(data) {
    if (data === void 0) { data = {}; }
    return new assessment_template_model_1.AssessmentTemplate((0, merge_1.default)({
        id: 'any-id',
        externalId: 'any-external-id',
        curriculum: constants_1.CurriculumId.EurekaMath,
        grade: 'any-grade',
        active: true,
        module: 'any-module',
        topic: 'any-topic',
        sequence: 1,
        subject: 'any-subject',
        title: 'any-title',
        subtitle: 'any-subtitle',
        settings: 'any-settings',
        manualScoring: false,
        owner: mockUser({ id: 'any-user-id' }),
        items: [mockItem()],
        dok: 'hard',
        status: 'draft',
        createdAt: new Date(),
        stimulus: {
            title: 'Stimulus Title',
            author: 'Stimulus Author',
            textType: 'Info',
        },
        type: constants_1.AssessmentType.Assessment,
        assignmentType: constants_1.AssignmentType.EndOfModuleAssessment,
        itemStandards: [
            {
                externalItemId: 'GREA_9982',
                standardGlobalIds: ['CC-CCSS$A6676C2E$CCSS.Math.Content.1.MD.A'],
                standardSetGlobalId: 'global-id',
                hierarchyLevel: '1',
            },
            {
                externalItemId: 'GREA_9982',
                standardGlobalIds: ['CC-CCSS$A666E380$CCSS.Math.Content.1.MD'],
                standardSetGlobalId: 'global-id',
                hierarchyLevel: '1',
            },
            {
                externalItemId: 'GREA_9982',
                standardGlobalIds: ['CC-CCSS$A667E604$CCSS.Math.Content.1.MD.A.1'],
                standardSetGlobalId: 'global-id',
                hierarchyLevel: '1',
            },
            {
                externalItemId: 'GREA_9982',
                hierarchyLevel: null,
                standardGlobalIds: null,
                standardId: '432c9720-c431-4703-a9d4-330c349d82b7',
                standardSetGlobalId: null,
                standardSetId: '991ecf9f-443f-41bd-baa9-e9384ddf80e1',
            },
            {
                externalItemId: 'GREA_9982',
                standardGlobalIds: ['CC-CCSS$A6686BD8$CCSS.Math.Content.1.MD.A.2'],
                standardSetGlobalId: 'global-id',
                hierarchyLevel: '1',
            },
        ],
        language: 'English',
        resourceItemIds: ['any-resource'],
        noStudentSubmissionsFlow: false,
    }, data));
}
function mockAssessmentTemplateEmtx(data) {
    if (data === void 0) { data = {}; }
    return new assessment_template_model_1.AssessmentTemplate((0, merge_1.default)({
        id: 'any-id',
        externalId: 'any-external-id',
        curriculum: constants_1.CurriculumId.EurekaMathTX,
        grade: 'any-grade',
        module: 'any-module',
        topic: 'any-topic',
        sequence: 1,
        subject: 'any-subject',
        title: 'any-title',
        subtitle: 'any-subtitle',
        settings: 'any-settings',
        manualScoring: false,
        owner: mockUser({ id: 'any-user-id' }),
        items: [mockItemEMTX()],
        dok: 'hard',
        status: 'draft',
        createdAt: new Date(),
        stimulus: {
            title: 'Stimulus Title',
            author: 'Stimulus Author',
            textType: 'Info',
        },
        type: constants_1.AssessmentType.Assessment,
        assignmentType: constants_1.AssignmentType.EndOfModuleAssessment,
        itemStandards: [
            {
                externalItemId: 'GREA_82_tx',
                standardGlobalIds: ['TX-TEKS$73E603EE$MA.1.5.E'],
                standardSetGlobalId: 'TX-TEKS',
                hierarchyLevel: 'Knowledge/Skill',
            },
            {
                externalItemId: 'GREA_75_tx',
                standardGlobalIds: ['TX-TEKS$73E203EE$MA.1.7.F'],
                standardSetGlobalId: 'TX-TEKS',
                hierarchyLevel: 'Knowledge/Skill',
            },
            {
                externalItemId: 'GREA_75_tx',
                hierarchyLevel: null,
                standardGlobalIds: null,
                standardId: '432c9720-c431-4703-a9d4-330c349d82b7',
                standardSetGlobalId: null,
                standardSetId: '991ecf9f-443f-41bd-baa9-e9384ddf80e1',
            },
            {
                externalItemId: 'GREA_72_tx',
                standardGlobalIds: ['TX-TEKS$73E803EE$MA.1.3.D'],
                standardSetGlobalId: 'TX-TEKS',
                hierarchyLevel: 'Knowledge/Skill',
            },
        ],
    }, data));
}
function mockAssessment(data) {
    if (data === void 0) { data = {}; }
    return new assessment_model_1.Assessment((0, merge_1.default)({
        id: 'any-id',
        assessmentTemplate: mockAssessmentTemplate({ id: 'any-assessment-template-id' }),
        settings: {
            player: {
                calculator: 'basic',
                shuffleAnswers: false,
                shuffleQuestions: false,
                timer: 10,
            },
            scores: {
                showWhenStudentSubmitted: true,
                showWhenClassSubmitted: true,
                showWhenClassDone: true,
            },
        },
        status: constants_1.AssessmentStatus.Assigned,
        autoLaunch: false,
        assignedAt: new Date(),
        finishedAt: new Date(),
        bundleId: 'any-bundle-id',
        assessmentClass: mockClass({ id: 'any-class-id' }),
        endDate: new Date(),
        owner: mockUser({ id: 'any-user-id' }),
        startDate: new Date(),
        totalSubmitted: 10,
        totalAssigned: 20,
        type: constants_1.AssessmentType.Assessment,
        usesCustomRubrics: true,
        noStudentSubmissionsFlow: false,
    }, data));
}
function mockAgsAssessment(data) {
    if (data === void 0) { data = {}; }
    return new ags_assessment_model_1.AgsAssessment((0, merge_1.default)({
        id: 'any-id',
        status: constants_1.AssessmentStatus.Assigned,
        autoLaunch: false,
        contextId: 'context-id',
        title: 'Ags Assessment',
        startDate: new Date(),
        createdAt: new Date(),
        updatedAt: new Date(),
        avgScore: 1,
        maxScore: 2,
        assessmentClass: mockClass({ id: 'any-class-id' }),
        createdBy: mockUser({ id: 'any-user-id' }),
        curriculum: constants_1.CurriculumId.EurekaMath,
    }, data));
}
function mockAttempt(data) {
    if (data === void 0) { data = {}; }
    return new attempt_model_1.Attempt((0, merge_1.default)({
        id: 'any-id',
        score: 30,
        startedAt: new Date(),
        status: constants_1.AttemptStatus.Submitted,
        assignee: mockUser({ id: 'any-user-id' }),
        assessment: mockAssessment({ id: 'any-assessment-id' }),
        maxScore: 50,
        updatedAt: new Date(),
        closedAt: new Date(),
        responses: [mockItemResponse()],
        feedback: [mockFeedback()],
        completedOnPaper: false,
        isGraded: true,
        reopenedAt: null,
    }, data));
}
function mockAttemptRubricSelection(data) {
    if (data === void 0) { data = {}; }
    return new __1.AttemptRubricSelection((0, merge_1.default)({
        id: 'id-1',
        attempt: mockAttempt({ assessment: mockAssessment({ id: 'any-id', settings: null }) }),
        responses: [
            {
                answerDoesNotApply: false,
                externalQuestionId: '1',
                criteriaSelections: [
                    {
                        categoryId: '1',
                        criterionId: '1',
                        ratingId: '1',
                    },
                ],
            },
        ],
    }, data));
}
function mockAssignment(data) {
    if (data === void 0) { data = {}; }
    return new assignment_model_1.Assignment((0, merge_1.default)({
        title: 'any-title',
        contextId: 'any-context',
        contextType: 'any-context-type',
        schoolId: 'any-school-id',
        startDate: new Date(),
        endDate: new Date(),
        assigneeIds: ['some', 'assigneeIds'],
        autoLaunch: true,
        settings: mockSettingOptions(),
    }, data));
}
function mockItem(data) {
    if (data === void 0) { data = {}; }
    return new item_model_1.Item((0, merge_1.default)({
        externalId: 'any-external-id',
        externalBankItemId: 'any-external-bank-item-id',
        title: 'any-title',
        description: 'any-description',
        standards: ['CC12', 'CCAB'],
        _standards: [
            'CC-CCSS$A6676C2E$CCSS.Math.Content.1.MD.A',
            'CC-CCSS$A6676C2E$CCSS.Math.Content.1.MD.B',
        ],
        childStandards: ['CC', 'AB'],
        domains: ['D1', 'D2'],
        clusters: ['C1', 'C2'],
        dok: 'normal',
        maxScore: 0,
        manualScoring: false,
        questions: [mockQuestion()],
        type: constants_1.ItemType.Core,
        scoringType: constants_1.ScoringType,
        label: '1',
        foundational: 'test',
        variation: 'Variation A',
        standardsByHierarchy: [
            mockStandardsByHierarchy({
                hierarchyLevel: 'Standard',
                standardGlobalIds: [
                    'CC-CCSS$A667E604$CCSS.Math.Content.1.MD.A.1',
                    'CC-CCSS$A654C16E$CCSS.Math.Content.1.OA.A.1',
                ],
            }),
        ],
    }, data));
}
function mockItemEMTX(data) {
    if (data === void 0) { data = {}; }
    return new item_model_1.Item((0, merge_1.default)({
        externalId: 'any-external-id',
        externalBankItemId: 'any-external-bank-item-id',
        title: 'any-title',
        description: 'any-description',
        dok: 'normal',
        maxScore: 0,
        manualScoring: false,
        questions: [mockQuestion()],
        type: constants_1.ItemType.Core,
        label: '1',
        foundational: 'test',
        variation: 'Variation A',
        standardsByHierarchy: [
            mockStandardsByHierarchy({
                hierarchyLevel: 'Knowledge/Skill',
                standardGlobalIds: ['TX-TEKS$73E06BD2$MA.1.3.B', 'TX-TEKS$73E59D6E$MA.1.5.D'],
            }),
        ],
    }, data));
}
function mockQuestion(data) {
    if (data === void 0) { data = {}; }
    return new question_model_1.Question((0, merge_1.default)({
        externalId: 'any-external-id',
        description: 'any-description',
        type: 'mc',
        maxScore: 0,
    }, data));
}
function mockStimulus(data) {
    if (data === void 0) { data = {}; }
    return new stimulus_model_1.Stimulus((0, merge_1.default)({
        title: 'Stimulus Title',
        author: 'Stimulus Author',
        textType: 'Stimulus Text Type',
    }, data));
}
function mockCurriculum(data) {
    if (data === void 0) { data = {}; }
    return new curriculum_1.Curriculum((0, merge_1.default)({
        id: constants_1.CurriculumId.EurekaMath,
        name: constants_1.CurriculumName.EurekaMath,
        description: 'Eureka Math Curriculum',
        grades: [mockGrade({ id: 'grade-1' })],
    }, data));
}
function mockEurekaMathCurriculum() {
    return mockCurriculum({
        id: constants_1.CurriculumId.EurekaMath,
        name: constants_1.CurriculumName.EurekaMath,
    });
}
function mockEurekaMathTXCurriculum() {
    return mockCurriculum({
        id: constants_1.CurriculumId.EurekaMathTX,
        name: constants_1.CurriculumName.EurekaMathTX,
    });
}
function mockWitAndWisdomCurriculum() {
    return mockCurriculum({
        id: constants_1.CurriculumId.WitAndWisdom,
        name: constants_1.CurriculumName.WitAndWisdom,
    });
}
function mockGrade(data) {
    if (data === void 0) { data = {}; }
    return new curriculum_1.Grade((0, merge_1.default)({
        id: 'grade-1',
        name: 'Grade 1',
        description: 'Grade 1 Description',
        modules: [mockModule({ id: 'module-1' })],
    }, data));
}
function mockModule(data) {
    if (data === void 0) { data = {}; }
    return new curriculum_1.Module((0, merge_1.default)({
        id: 'module-1',
        name: 'Module 1',
        description: 'Module 1 Description',
        topics: [mockTopic()],
        lessons: [mockLesson()],
        assessmentTemplates: [mockAssessmentTemplate({ id: 'any-assessment-template-id' })],
    }, data));
}
function mockLesson(data) {
    if (data === void 0) { data = {}; }
    return new __1.Lesson((0, merge_1.default)({
        id: 'lesson-1',
        name: 'Lesson 1',
        itemSets: [
            {
                id: 'set-a',
                name: 'Set A',
            },
        ],
    }, data));
}
function mockTopic(data) {
    if (data === void 0) { data = {}; }
    return new __1.Topic((0, merge_1.default)({
        id: 'topic-a',
        name: 'Topic A',
        description: 'Topic A Description',
    }, data));
}
function mockItemResponse(data) {
    if (data === void 0) { data = {}; }
    return new item_response_1.ItemResponse((0, merge_1.default)({
        externalItemId: 'any-external-item-id',
        externalBankItemId: 'any-external-bank-item-id',
        responses: [mockQuestionResponse()],
        type: constants_1.ItemType.Core,
        itemScore: 1,
        itemMaxScore: 2,
    }, data));
}
function mockQuestionResponse(data) {
    if (data === void 0) { data = {}; }
    return new question_response_1.QuestionResponse((0, merge_1.default)({
        externalResponseId: 'any-response-id',
        externalQuestionId: 'any-question-id',
        score: 5,
        maxScore: 10,
        attempted: true,
    }, data));
}
function mockFeedback(data) {
    if (data === void 0) { data = {}; }
    return new feedback_model_1.Feedback((0, merge_1.default)({
        id: 'any-id',
        itemExternalId: 'any-external-id',
        feedback: 'any-feedback',
        createdBy: 'any-created-by',
    }, data));
}
function mockPerformanceBand(data) {
    if (data === void 0) { data = {}; }
    return new __1.PerformanceBand((0, merge_1.default)({
        id: '1',
        min: 0,
        max: 10,
        curriculum: constants_1.CurriculumId.EurekaMath,
        code: 'not-proficient',
    }, data));
}
function mockPerformanceBandEmtx(data) {
    if (data === void 0) { data = {}; }
    return new __1.PerformanceBand((0, merge_1.default)({
        id: '1',
        min: 0,
        max: 10,
        curriculum: constants_1.CurriculumId.EurekaMathTX,
        code: 'not-proficient',
    }, data));
}
function mockSettingsPerformanceBand(data) {
    if (data === void 0) { data = {}; }
    return new settings_performance_band_model_1.SettingsPerformanceBand((0, merge_1.default)({
        min: 0,
        max: 10,
        code: 'not-proficient',
    }, data));
}
function mockItemPerformance(data) {
    if (data === void 0) { data = {}; }
    return new item_performance_model_1.ItemPerformance((0, merge_1.default)({
        item: mockItem(),
        percentage: 50,
        score: 5,
        maxScore: 10,
        band: mockPerformanceBand(),
        index: 1,
    }, data));
}
function mockAssessmentPerformanceBandDistribution(data) {
    if (data === void 0) { data = {}; }
    return new assessment_performance_band_distribution_model_1.AssessmentPerformanceBandDistribution((0, merge_1.default)({
        assessment: mockAssessment(),
        distribution: [mockPerformanceBandDistribution()],
    }, data));
}
function mockPlayerOptions(data) {
    if (data === void 0) { data = {}; }
    return new player_options_model_1.PlayerOptions((0, merge_1.default)({
        calculator: 'off',
        shuffleAnswers: true,
        shuffleQuestions: false,
        timer: -1,
        highlighter: true,
        notepad: true,
        checkAnswers: false,
    }, data));
}
function mockScoreOptions(data) {
    if (data === void 0) { data = {}; }
    return new score_options_model_1.ScoreOptions((0, merge_1.default)({
        showWhenStudentSubmitted: false,
        showWhenClassSubmitted: false,
        showWhenClassDone: true,
    }, data));
}
function mockReportingOptions(data) {
    if (data === void 0) { data = {}; }
    return new reporting_options_model_1.ReportingOptions((0, merge_1.default)({
        performanceBands: [
            new settings_performance_band_model_1.SettingsPerformanceBand({
                code: 'not-proficient',
                min: 0,
                max: 60,
            }),
            new settings_performance_band_model_1.SettingsPerformanceBand({
                code: 'partially-proficient',
                min: 61,
                max: 70,
            }),
            new settings_performance_band_model_1.SettingsPerformanceBand({
                code: 'proficient',
                min: 71,
                max: 90,
            }),
            new settings_performance_band_model_1.SettingsPerformanceBand({
                code: 'highly-proficient',
                min: 91,
                max: 100,
            }),
        ],
        standardPerformanceBands: [
            new settings_performance_band_model_1.SettingsPerformanceBand({
                code: 'not-proficient',
                min: 0,
                max: 60,
            }),
            new settings_performance_band_model_1.SettingsPerformanceBand({
                code: 'partially-proficient',
                min: 61,
                max: 70,
            }),
            new settings_performance_band_model_1.SettingsPerformanceBand({
                code: 'proficient',
                min: 71,
                max: 90,
            }),
            new settings_performance_band_model_1.SettingsPerformanceBand({
                code: 'highly-proficient',
                min: 91,
                max: 100,
            }),
        ],
    }, data));
}
function mockAssessmentTypeOptions(data) {
    if (data === void 0) { data = {}; }
    return new assessment_type_options_model_1.AssessmentTypeOptions((0, merge_1.default)({
        moduleAssessmentsEnabled: true,
        topicQuizEnabled: false,
    }, data));
}
function mockStandardsOptions(data) {
    if (data === void 0) { data = {}; }
    return new standards_options_model_1.StandardsOptions((0, merge_1.default)({
        standardSets: [mockStandardSet()],
    }, data));
}
function mockStandardSet(data) {
    if (data === void 0) { data = {}; }
    return new standard_set_model_1.StandardSet((0, merge_1.default)({
        code: 'common',
        name: 'Common Standards',
    }, data));
}
function mockOption(data) {
    if (data === void 0) { data = {}; }
    return new option_model_1.Option((0, merge_1.default)({
        player: mockPlayerOptions(),
        scores: mockScoreOptions(),
        reporting: mockReportingOptions(),
        customization: mockAssessmentTypeOptions(),
        assign: mockAssessmentTypeOptions(),
        standards: mockStandardsOptions(),
    }, data));
}
function mockAdminOption(data) {
    if (data === void 0) { data = {}; }
    return new option_model_1.Option((0, merge_1.default)({
        player: undefined,
        scores: undefined,
        reporting: mockReportingOptions(),
        customization: mockAssessmentTypeOptions(),
        assign: mockAssessmentTypeOptions(),
        standards: mockStandardsOptions(),
    }, data));
}
function mockSettingOptions(data) {
    if (data === void 0) { data = {}; }
    return new setting_options_model_1.SettingOptions((0, merge_1.default)({
        id: 'any-setting-options',
        curriculum: constants_1.CurriculumId.EurekaMath,
        type: 'user',
        options: mockOption(),
    }, data));
}
function mockAdminSettingOptions(data) {
    if (data === void 0) { data = {}; }
    return new setting_options_model_1.SettingOptions((0, merge_1.default)({
        id: 'any-setting-options',
        curriculum: constants_1.CurriculumId.EurekaMath,
        type: 'district',
        options: mockAdminOption(),
    }, data));
}
function mockWWSettingOptions(data) {
    if (data === void 0) { data = {}; }
    return new setting_options_model_1.SettingOptions((0, merge_1.default)({
        id: 'any-setting-options',
        curriculum: constants_1.CurriculumId.WitAndWisdom,
        type: 'user',
        options: mockOption(),
    }, data));
}
function mockAssigneePerformance(data) {
    if (data === void 0) { data = {}; }
    return new assignee_performance_model_1.AssigneePerformance((0, merge_1.default)({
        assignee: mockUser({ id: 'any-user-id' }),
        overallPercentage: 100,
        score: 10,
        maxScore: 10,
        overallPerformanceBand: mockPerformanceBand({ code: 'proficient' }),
        itemsPerformance: [
            new item_performance_model_1.ItemPerformance({
                item: mockItem({ externalId: 'a' }),
                band: mockPerformanceBand({ code: 'proficient' }),
                percentage: 100,
                maxScore: 10,
                score: 10,
                index: 1,
            }),
        ],
        assessmentTemplateId: 'any-assessment-template-id',
    }, data));
}
function mockAssigneePerformanceWW(data) {
    if (data === void 0) { data = {}; }
    return new assignee_performance_ww_model_1.AssigneePerformanceWW((0, merge_1.default)({
        assignee: mockUser({ id: 'any-user-id' }),
        attempts: 1,
        overallPercentage: 50,
        score: 1,
        maxScore: 2,
        classId: 'any-class-id',
        itemQuestionsPerformance: [
            mockItemQuestionPerformance({ externalQuestionId: 'iq-1' }),
            mockItemQuestionPerformance({ externalQuestionId: 'iq-2' }),
        ],
    }, data));
}
function mockClassPerformance(data) {
    if (data === void 0) { data = {}; }
    return new class_performance_model_1.ClassPerformance((0, merge_1.default)({
        class: [mockClass({ id: 'a' })],
        overallPercentage: 100,
        overallPerformanceBand: mockPerformanceBand({
            code: 'proficient',
            curriculum: constants_1.CurriculumId.EurekaMath,
        }),
        itemsPerformance: [
            new item_performance_model_1.ItemPerformance({
                item: mockItem({ externalId: 'a' }),
                band: mockPerformanceBand({
                    code: 'proficient',
                    curriculum: constants_1.CurriculumId.EurekaMath,
                }),
                percentage: 100,
                index: 1,
            }),
        ],
    }, data));
}
function mockAssigneeStandardPerformance(data) {
    if (data === void 0) { data = {}; }
    return new __1.AssigneeStandardPerformance((0, merge_1.default)({
        assignee: mockUser(),
        overallPercentage: 80,
        maxScore: 100,
        score: 80,
        overallPerformanceBand: mockPerformanceBand(),
        standardsPerformance: [
            mockStandardPerformance({ standard: 'a' }),
            mockStandardPerformance({ standard: 'b' }),
        ],
    }, data));
}
function mockAssigneeStandardPerformanceEmtx(data) {
    if (data === void 0) { data = {}; }
    return new __1.AssigneeStandardPerformance((0, merge_1.default)({
        assignee: mockUser(),
        overallPercentage: 80,
        maxScore: 100,
        score: 80,
        overallPerformanceBand: mockPerformanceBandEmtx(),
        standardsPerformance: [
            mockStandardPerformance({ standard: 'a', band: mockPerformanceBandEmtx() }),
            mockStandardPerformance({ standard: 'b', band: mockPerformanceBandEmtx() }),
        ],
    }, data));
}
function mockStandardPerformance(data) {
    if (data === void 0) { data = {}; }
    return new __1.StandardPerformance((0, merge_1.default)({
        band: mockPerformanceBand(),
        percentage: 50,
        maxScore: 100,
        score: 50,
        totalItems: 2,
        standard: 'A',
        attempted: false,
    }, data));
}
function mockSkippedItemResponse(data) {
    if (data === void 0) { data = {}; }
    return (0, merge_1.default)({
        assessmentTemplateId: 'template-1',
        contextId: 'any-id',
        items: [
            {
                itemId: 'item-1',
                skipCount: 3,
                skipPercentage: 30,
            },
            {
                itemId: 'item-2',
                skipCount: 5,
                skipPercentage: 50,
            },
            {
                itemId: 'item-3',
                skipCount: 1,
                skipPercentage: 10,
            },
        ],
    }, data);
}
function mockStandardPerformanceBandDistribution(data) {
    return new standard_performance_band_distribution_model_1.StandardPerformanceBandDistribution((0, merge_1.default)({
        standard: 'a',
        distribution: [mockPerformanceBandDistribution(), mockPerformanceBandDistribution()],
    }, data));
}
function mockPerformanceBandDistribution(data) {
    if (data === void 0) { data = {}; }
    return (0, merge_1.default)({
        band: mockPerformanceBand(),
        sample: 10,
        percentage: 80,
    }, data);
}
function mockOverallStandardPerformance(data) {
    if (data === void 0) { data = {}; }
    return new __1.OverallStandardPerformance((0, merge_1.default)({
        classes: [mockClass({ id: 'a' })],
        overallPercentage: 100,
        overallPerformanceBand: mockPerformanceBand({ code: 'proficient' }),
        standardsPerformance: [mockStandardPerformance(), mockStandardPerformance()],
    }, data));
}
function mockAssessmentCompletionSummary(data) {
    if (data === void 0) { data = {}; }
    return new assessment_completion_summary_model_1.AssessmentCompletionSummary((0, merge_1.default)({
        submitted: 10,
        unattempted: 5,
    }, data));
}
function mockReopenAssessmentCount(data) {
    if (data === void 0) { data = {}; }
    return (0, merge_1.default)({
        assigneeId: 'some-user-level-setting-user-id',
        assessmentAssignedCount: 1,
        reopenCount: 1,
    }, data);
}
function mockAssessmentPerformanceInfo(data) {
    if (data === void 0) { data = {}; }
    return (0, merge_1.default)({
        highestPerformance: [
            {
                id: 'any-highest-assessment',
                title: 'title for highest assessment',
            },
        ],
        lowestPerformance: [
            {
                id: 'any-lowest-assessment',
                title: 'title for lowest assessment',
            },
        ],
    }, data);
}
function mockAssessmentPerformance(data) {
    if (data === void 0) { data = {}; }
    return new assessment_performance_model_1.AssessmentPerformance((0, merge_1.default)({
        assessment: mockAssessment(),
        score: 10,
        maxScore: 20,
        percentage: 50,
        performanceBand: mockPerformanceBand(),
        totalAssignees: 1,
    }, data));
}
function mockAssessmentPerformanceWW(data) {
    if (data === void 0) { data = {}; }
    return new assessment_performance_ww_model_1.AssessmentPerformanceWW((0, merge_1.default)({
        assessmentTemplate: mockAssessmentTemplate(),
        percentage: 50,
        maxScore: 2,
        assessmentTemplateMaxScore: 2,
        score: 1,
        averageScore: 1,
        sectionId: 'any-id',
        averageTimeSpent: 20,
        assigned: true,
    }, data));
}
function mockDomain(data) {
    if (data === void 0) { data = {}; }
    return new standards_1.Domain((0, merge_1.default)({
        id: 'G.D',
        name: 'domain',
        description: 'domain description',
        grade: 'grade',
        clusters: [mockCluster()],
    }, data));
}
function mockParentDomain(data) {
    if (data === void 0) { data = {}; }
    return new standards_1.Domain((0, merge_1.default)({
        id: 'G.D',
        name: 'domain',
        description: 'domain description',
        grade: 'grade',
        clusters: [],
    }, data));
}
function mockCluster(data) {
    if (data === void 0) { data = {}; }
    return new standards_1.Cluster((0, merge_1.default)({
        id: 'G.D.C',
        name: 'cluster',
        description: 'cluster description',
        standards: [mockStandard()],
        domain: mockParentDomain(),
    }, data));
}
function mockParentCluster(data) {
    if (data === void 0) { data = {}; }
    return new standards_1.Cluster((0, merge_1.default)({
        id: 'G.D.C',
        name: 'cluster',
        description: 'cluster description',
        standards: [],
        domain: mockParentDomain(),
    }, data));
}
function mockStandard(data) {
    if (data === void 0) { data = {}; }
    return new standards_1.Standard((0, merge_1.default)({
        id: 'G.D.C.S',
        name: 'standard',
        description: 'standard description',
        childStandards: [mockChildStandard()],
        cluster: mockParentCluster(),
    }, data));
}
function mockStandardItem(data) {
    if (data === void 0) { data = {}; }
    return new standards_1.StandardItem((0, merge_1.default)({
        id: '189999fd-22b0-44c3-a8d4-ce5640ce2c38',
        globalId: 'CC-CCSS$2045CFDA$CCSS.Math.Content.HSF-BF.A.1',
        code: 'CCSS.Math.Content.HSF-BF.A.1',
        shortCode: 'HSF-BF.A.1',
        description: 'standard description',
        subjectId: 'mock',
        courseId: null,
        standardSetId: '2bffc693-ac4c-4553-909f-ef192360bfbc',
        hierarchyLevel: 'Standard',
        hierarchyLevelSequence: 30028,
        ancestors: [
            {
                id: '935f8ce4-ced9-43a1-8ba1-b81ee57f1c56',
                globalId: 'CC-CCSS$20441F28$CCSS.Math.Content.HSF-BF.A',
                code: 'CCSS.Math.Content.HSF-BF.A',
                shortCode: 'HSF-BF.A',
                description: 'cluster description',
                subjectId: null,
                courseId: null,
                standardSetId: '2bffc693-ac4c-4553-909f-ef192360bfbc',
                hierarchyLevel: 'Cluster Statement',
                hierarchyLevelSequence: 20027,
            },
            {
                id: 'e6231d3e-caa8-4239-83a2-0a3b852170d3',
                globalId: 'CC-CCSS$2042533C$CCSS.Math.Content.HSF-BF',
                code: 'CCSS.Math.Content.HSF-BF',
                shortCode: 'HSF-BF',
                description: 'domain description',
                subjectId: null,
                courseId: null,
                standardSetId: '2bffc693-ac4c-4553-909f-ef192360bfbc',
                hierarchyLevel: 'Domain',
                hierarchyLevelSequence: 10026,
            },
        ],
    }, data));
}
function mockStandardItemEmtx(data) {
    if (data === void 0) { data = {}; }
    return new standards_1.StandardItem((0, merge_1.default)({
        id: '6c230b0e-65e7-4ecf-90ab-96f0b033dfa4',
        globalId: 'TX-TEKS$9EC8CF1E$MA.5.3.K',
        code: 'MA.5.3.K',
        shortCode: '5.3.K',
        description: 'Teks Description',
        subjectId: '2ac8bfb7-b2ba-46cd-8c86-c9d4d8139050',
        courseId: 'd82511df-7b99-4be3-891b-7e2d590735e3',
        standardSetId: '032a76a9-13c7-4353-bac7-49a045dd04b6',
        hierarchyLevel: 'Knowledge/Skill',
        hierarchyLevelSequence: 20024,
        ancestors: [
            {
                id: 'b0e910bb-4f04-41e9-a480-1cacf56703be',
                globalId: 'TX-TEKS$9EC3B79A$MA.5.3',
                code: 'MA.5.3',
                shortCode: '5.3',
                description: 'Strand Description',
                subjectId: '2ac8bfb7-b2ba-46cd-8c86-c9d4d8139050',
                courseId: 'd82511df-7b99-4be3-891b-7e2d590735e3',
                standardSetId: '032a76a9-13c7-4353-bac7-49a045dd04b6',
                hierarchyLevel: 'Strand',
                hierarchyLevelSequence: 10013,
            },
        ],
    }, data));
}
function mockChildStandard(data) {
    if (data === void 0) { data = {}; }
    return new standards_1.ChildStandard((0, merge_1.default)({
        id: 'G.D.C.S.c',
        name: 'child standard',
        description: 'child standard description',
        cluster: mockParentCluster(),
    }, data));
}
function mockItemStandard(data) {
    if (data === void 0) { data = {}; }
    return new standards_1.ItemStandard((0, merge_1.default)({
        externalItemId: 'GREA_9982',
        standardGlobalIds: ['G.D.C.S'],
        standardId: 'f443e30e-ecda-4150-b1ee-d4928687e269',
        standardSetGlobalId: 'global-id',
        standardSetId: 'f2272e24-81d8-432c-9830-2e9bfb2539e9',
        hierarchyLevel: '1',
    }, data));
}
function mockItemStandardEmtx(data) {
    if (data === void 0) { data = {}; }
    return new standards_1.ItemStandard((0, merge_1.default)({
        externalItemId: 'GREA_9982',
        standardGlobalIds: ['TX-TEKS$73E06BD2$MA.1.3.B'],
        standardId: 'f443e30e-ecda-4150-b1ee-d4928687e269',
        standardSetGlobalId: 'TX-TEKS',
        standardSetId: 'f2272e24-81d8-432c-9830-2e9bfb2539e9',
        hierarchyLevel: 'Knowledge/Skill',
    }, data));
}
function mockAssessmentTemplateItemStandard(data) {
    if (data === void 0) { data = {}; }
    return new standards_1.AssessmentTemplateItemStandard((0, merge_1.default)({
        assessmentTemplateId: 'assessment-template-1',
        itemStandards: [
            {
                externalItemId: 'GREA_9982',
                standardGlobalIds: [
                    'CC-CCSS$A6676C2E$CCSS.Math.Content.1.MD.A',
                    'CC-CCSS$A666E380$CCSS.Math.Content.1.MD',
                    'CC-CCSS$A667E604$CCSS.Math.Content.1.MD.A.1',
                ],
                standardId: null,
                standardSetGlobalId: 'global-id',
                standardSetId: null,
                hierarchyLevel: '1',
            },
            {
                externalItemId: 'GREA_9982',
                hierarchyLevel: null,
                standardGlobalIds: null,
                standardId: '432c9720-c431-4703-a9d4-330c349d82b7',
                standardSetGlobalId: null,
                standardSetId: '991ecf9f-443f-41bd-baa9-e9384ddf80e1',
            },
        ],
    }, data));
}
function mockAssessmentTemplateItemStandardEmtx(data) {
    if (data === void 0) { data = {}; }
    return new standards_1.AssessmentTemplateItemStandard((0, merge_1.default)({
        assessmentTemplateId: 'assessment-template-1',
        itemStandards: [
            {
                externalItemId: 'GREA_9982',
                standardGlobalIds: [
                    'TX-TEKS$73E06BD2$MA.1.3.B',
                    'TX-TEKS$73E19E6C$MA.1.3.E',
                    'TX-TEKS$73E59D6E$MA.1.5.D',
                ],
                standardId: null,
                standardSetGlobalId: 'TX-TEKS',
                standardSetId: null,
                hierarchyLevel: 'Knowledge/Skill',
            },
            {
                externalItemId: 'GREA_9982',
                hierarchyLevel: null,
                standardGlobalIds: null,
                standardId: '432c9720-c431-4703-a9d4-330c349d82b7',
                standardSetGlobalId: null,
                standardSetId: '991ecf9f-443f-41bd-baa9-e9384ddf80e1',
            },
        ],
    }, data));
}
function mockLogout(data) {
    if (data === void 0) { data = {}; }
    return new logout_model_1.Logout((0, merge_1.default)({
        redirectUrl: 'https://clever.com/login',
    }, data));
}
function mockImpersonate(data) {
    if (data === void 0) { data = {}; }
    return (0, merge_1.default)({
        body: {
            'redirect-user': '/auth/impersonate/v2/end',
        },
    }, data);
}
function mockRoles(data) {
    if (data === void 0) { data = {}; }
    return new role_model_1.Role((0, merge_1.default)({
        activeRole: dp_acma_dawn_sdk_1.CognitoRole.TEACHER,
        availableRoles: [dp_acma_dawn_sdk_1.CognitoRole.TEACHER],
    }, data));
}
function mockItemQuestionPerformance(data) {
    if (data === void 0) { data = {}; }
    return new item_question_performance_model_1.ItemQuestionPerformance((0, merge_1.default)({
        itemExternalId: 'any-external-id',
        externalQuestionId: 'any-question-id',
        maxScore: 2,
        score: 0,
        percentage: 0,
        attempted: true,
        questionType: 'mcq',
        answer: [
            mockAnswer({ answer: '1' }),
            mockAnswer({ answer: '2' }),
            mockAnswer({ answer: '3' }),
        ],
        index: 1,
    }, data));
}
function mockItemWordPerformance(data) {
    if (data === void 0) { data = {}; }
    return new item_word_performance_model_1.ItemWordPerformance((0, merge_1.default)({
        key: 1,
        value: 'Word 1',
        isCorrect: true,
        score: 1,
        maxScore: 2,
        percentage: 50,
    }, data));
}
function mockClassPerformanceWW(data) {
    if (data === void 0) { data = {}; }
    return new class_performance_ww_model_1.ClassPerformanceWW((0, merge_1.default)({
        class: mockClass({ id: 'a' }),
        totalItems: 1,
        assessmentsPerformance: [mockAssessmentPerformanceWW()],
    }, data));
}
function mockAnswer(data) {
    if (data === void 0) { data = {}; }
    return new answer_model_1.Answer((0, merge_1.default)({
        answer: '1',
        percentage: 10,
        isCorrect: false,
    }, data));
}
function mockAssessmentClassPerformance(data) {
    if (data === void 0) { data = {}; }
    return new assessment_class_performance_model_1.AssessmentClassPerformance((0, merge_1.default)({
        assessment: mockAssessmentTemplate(),
        maxScore: 5,
        overallScore: 2.5,
        overallPercentage: 50,
        studentsActivity: true,
        performances: [mockAssessmentPerformanceWW()],
    }, data));
}
function mockAnswerOption(data) {
    if (data === void 0) { data = {}; }
    return new answer_option_model_1.AnswerOption((0, merge_1.default)({
        label: 'answer label',
        value: '0',
    }, data));
}
function mockMultipleChoiceQuestion(data) {
    if (data === void 0) { data = {}; }
    return new multiple_choice_question_model_1.MultipleChoiceQuestion((0, merge_1.default)({
        options: [mockAnswerOption()],
        correctAnswer: ['0'],
    }, data));
}
function mockStudentAssessmentPerformance(data) {
    if (data === void 0) { data = {}; }
    return new student_assessment_performance_model_1.StudentAssessmentPerformance((0, merge_1.default)({
        student: mockUser({ id: 'any-user-id' }),
        overallPercentage: 100,
        assigneesPerformance: [
            mockAssigneePerformance({ assessmentTemplateId: 'assessment-template-1' }),
            mockAssigneePerformance({ assessmentTemplateId: 'assessment-template-2' }),
        ],
    }, data));
}
function mockOverallStudentAssessmentPerformance(data) {
    if (data === void 0) { data = {}; }
    return new overall_student_assessment_performance_model_1.OverallStudentAssessmentPerformance((0, merge_1.default)({
        overallPercentage: 100,
        assigneesPerformance: [
            mockAssigneePerformance({ assessmentTemplateId: 'assessment-template-1' }),
            mockAssigneePerformance({ assessmentTemplateId: 'assessment-template-2' }),
        ],
    }, data));
}
function mockAssigneeAssessmentPerformance(data) {
    if (data === void 0) { data = {}; }
    return new assignee_assessment_performance_model_1.AssigneeAssessmentPerformance((0, merge_1.default)({
        assigneeId: 'assignee-id',
        overallPercentage: 20,
        maxScore: 2,
        score: 10,
        assessmentPerformances: [],
    }, data));
}
function mockGoogleAnalyticsConfiguration(data) {
    if (data === void 0) { data = {}; }
    return new configuration_1.GoogleAnalyticsConfiguration((0, merge_1.default)({
        trackId: 'trackId',
    }, data));
}
function mockAnalyticsConfiguration(data) {
    if (data === void 0) { data = {}; }
    return new configuration_1.AnalyticsConfiguration((0, merge_1.default)({
        dpAnalyticsEndpoint: 'dpAnalyticsEndpoint',
        dpAnalyticsKey: 'dpAnalyticsKey',
        avrMessage: 'avrMessage',
    }, data));
}
function mockConfiguration(data) {
    if (data === void 0) { data = {}; }
    return new configuration_1.Configuration((0, merge_1.default)({
        ga: mockGoogleAnalyticsConfiguration(),
        analytics: mockAnalyticsConfiguration(),
    }, data));
}
function mockQuestionRubricResponse(data) {
    if (data === void 0) { data = {}; }
    return new question_rubric_model_1.LrnQuestionRubricResponse((0, merge_1.default)({
        apiVersion: 'v2.151.6',
        revision: 1,
        type: 'numeric',
        value: '0',
    }, data));
}
function mockQuestionRubricResponses(data) {
    if (data === void 0) { data = {}; }
    return (0, isEmpty_1.default)(data)
        ? new question_rubric_model_1.LrnQuestionRubricResponses({
            'any-key': mockQuestionRubricResponse(),
        })
        : new question_rubric_model_1.LrnQuestionRubricResponses(data);
}
function mockQuestionRubric(data) {
    if (data === void 0) { data = {}; }
    return new question_rubric_model_1.QuestionRubric((0, merge_1.default)({
        id: 'any-question-rubric-id',
        attemptId: 'any-attempt-id',
        externalItemId: 'any-item-external-id',
        externalQuestionId: 'any-question-external-id',
        responses: mockQuestionRubricResponses(),
        score: 5,
    }, data));
}
function mockAssessmentTemplateUsage(data) {
    if (data === void 0) { data = {}; }
    return new assessment_template_usage_model_1.AssessmentTemplateUsage((0, merge_1.default)({
        id: 'assessment-template-id',
        totalAssessmentsAssigned: 6,
    }, data));
}
function mockLicense(data) {
    if (data === void 0) { data = {}; }
    return new license_model_1.License((0, merge_1.default)({
        product: {
            id: constants_1.ProductId.Affirm,
        },
        curriculum: {
            id: constants_1.CurriculumId.EurekaMath,
        },
    }, data));
}
function mockRecommendation(data) {
    if (data === void 0) { data = {}; }
    return new recommendation_model_1.Recommendation((0, merge_1.default)({
        assessmentTemplateId: 'assessment-id',
        externalItemId: 'external-id',
        cmsResourceId: 'cms-resource',
        cmsResourceLabel: 'Recommendation',
        cmsResourceType: constants_1.ResourceType.FollowUpAssessment,
    }, data));
}
function mockFoundational(data) {
    if (data === void 0) { data = {}; }
    return new standards_1.Foundational((0, merge_1.default)({
        code: 'G5_M1_EFK1',
        description: 'foundational description',
    }, data));
}
function mockStudentAssignment(data) {
    if (data === void 0) { data = {}; }
    return new assignment_model_2.StudentAssignment((0, merge_1.default)({
        id: 'any-assignment-id',
        districtId: 'any-district-id',
        schoolId: 'any-school-id',
        enrollmentPeriodId: 'any-enrollment-period-id',
        ownerId: 'any-owner-id',
        contextId: 'any-context-id',
        title: 'any-title',
        instructions: 'any-instructions',
        startedAt: new Date(),
        completedAt: new Date(),
        status: constants_1.UserAssignmentStatus.Assigned,
        assignedAt: new Date(),
        bundleId: 'any-bundle-id',
        curriculumId: constants_1.CurriculumId.EurekaMath,
        evidenceType: 'no_evidence',
    }, data));
}
function mockUserAssignment(data) {
    if (data === void 0) { data = {}; }
    return new user_assignment_model_1.UserAssignment((0, merge_1.default)({
        id: 'any-user-assignment-id',
        assignment: mockStudentAssignment(),
        districtId: 'any-district-id',
        schoolId: 'any-school-id',
        dueDate: new Date(),
        enrollmentPeriodId: 'any-enrollment-period-id',
        assigneeId: 'any-assignee-id',
        startedAt: new Date(),
        completedAt: new Date(),
        status: constants_1.UserAssignmentStatus.Assigned,
    }, data));
}
function mockRubricCriteriaPerformance(data) {
    if (data === void 0) { data = {}; }
    return new rubric_criteria_performance_model_1.RubricCriteriaPerformance((0, merge_1.default)({
        key: 1,
        score: 5,
        maxScore: 10,
        percentage: 50,
    }, data));
}
function mockRubricRating(data) {
    if (data === void 0) { data = {}; }
    return new question_rubric_model_1.RubricRating((0, merge_1.default)({
        userId: 'user-1',
        externalId: 'external-id-1',
        responses: [
            new question_rubric_model_1.QuestionRubricResponses({
                key: 1,
                value: 0,
            }),
        ],
    }, data));
}
function mockRubricCriteria(data) {
    if (data === void 0) { data = {}; }
    return new question_rubric_model_1.RubricCriteria((0, merge_1.default)({
        externalId: 'external-id-1',
        criteria: [1, 2, 3],
    }, data));
}
function mockAssigneeRubricPerformance(data) {
    if (data === void 0) { data = {}; }
    return new assignee_rubric_performance_model_1.AssigneeRubricPerformance((0, merge_1.default)({
        assignee: mockUser(),
        rubricCriteriaPerformances: [mockRubricCriteriaPerformance()],
        maxScore: 1,
        overallPercentage: 100,
        score: 1,
    }, data));
}
function mockSchool(data) {
    if (data === void 0) { data = {}; }
    return new school_model_1.School((0, merge_1.default)({
        id: 'any-id',
        name: 'any-name',
    }, data));
}
function mockAdminSearchTemplate(data) {
    if (data === void 0) { data = {}; }
    return new admin_search_template_model_1.AdminSearchTemplate((0, merge_1.default)({
        title: 'Assessment Template',
        assessmentTemplateId: '1235',
    }, data));
}
function mockCurriculumAndProduct(data) {
    if (data === void 0) { data = {}; }
    return new curriculum_product_model_1.CurriculumProduct((0, merge_1.default)({
        curriculum: constants_1.CurriculumId.EurekaMath,
        productIds: [constants_1.ProductId.Affirm],
    }, data));
}
function mockSchoolYear(data) {
    if (data === void 0) { data = {}; }
    return (0, merge_1.default)({
        id: 'any-id',
        name: 'any-name',
        startDate: new Date('2020-08-01'),
        endDate: new Date('2021-07-31'),
    }, data);
}
function mockToken(data) {
    if (data === void 0) { data = {}; }
    return new Auth_1.Token((0, merge_1.default)({
        accessToken: 'abcd',
    }, data));
}
var mockAuthContextState = function (data) {
    return (0, dp_testing_lib_1.mock)(__assign({ user: mockUser(), schoolYear: mockSchoolYear() }, data));
};
exports.mockAuthContextState = mockAuthContextState;
function mockStandardsByHierarchy(data) {
    if (data === void 0) { data = {}; }
    return new standards_1.StandardsByHierarchy((0, merge_1.default)({
        standardGlobalIds: ['CC-CCSS$A667E604$CCSS.Math.Content.1.MD.A.1'],
        hierarchyLevel: 'Standard',
    }, data));
}
function mockDistrictStaff(data) {
    if (data === void 0) { data = {}; }
    return new __1.DistrictStaff((0, merge_1.default)({
        id: 'any-id',
        firstName: 'Ric',
        lastName: 'Black',
        roles: [constants_1.UserRole.Teacher],
        teacher: { id: 'any-teacher-id', teacherId: 'teacher-id' },
    }, data));
}
function mockAdminAssessmentList(data) {
    if (data === void 0) { data = {}; }
    return new admin_assessment_list_model_1.AdminAssessmentList((0, merge_1.default)({
        templateId: 'any-template-id',
        title: 'any-title',
        score: 50,
        maxScore: 100,
        percentage: 50,
        schoolCount: 5,
        gradeCount: 6,
        classCount: 12,
        teacherCount: 12,
    }, data));
}
function mockAverageScoreSchoolAvr(data) {
    if (data === void 0) { data = {}; }
    return new average_score_school_avr_model_1.AverageScoreSchoolAvr((0, merge_1.default)({
        schoolId: 'any-school-id',
        schoolName: 'any-school',
        score: 8.5,
        maxScore: 10,
        percentage: 85,
        performance: 'Proficient',
    }, data));
}
function mockAverageScoreClassAvr(data) {
    if (data === void 0) { data = {}; }
    return new __2.AverageScoreClassAvr((0, merge_1.default)({
        classId: '3',
        className: 'class 3',
        schoolId: '974db194-7693-402e-acc3-33ae338b63cf',
        schoolName: 'Assessment school One',
        score: 8.5,
        maxScore: 10,
        percentage: 85,
        performance: 'Proficient',
    }, data));
}
function mockAvrStandardAverageScore(data) {
    if (data === void 0) { data = {}; }
    return ((0, merge_1.default)({
        classCount: 3,
        exposureCount: 15,
        maxScore: 201,
        percentage: 35,
        schoolCount: 2,
        score: 69.46,
        standardSetGlobal: 'CC-CCSS',
        standardsCount: 7,
        studentCount: 7,
        teacherCount: 2,
        templateCount: 6,
    }),
        data);
}
function mockAvrStandarddistributions(data) {
    if (data === void 0) { data = {}; }
    return ((0, merge_1.default)({
        maxScore: 23,
        percentage: 13,
        score: 3,
        standardDescription: 'Use addition and subtraction within 20 to solve word problems involving situations of adding to, taking from, putting together, taking apart, and comparing, with unknowns in all positions, e.g., by using objects, drawings, and equations with a symbol for the unknown number to represent the problem.',
        standardItemGlobal: 'CC-CCSS$A654C16E$CCSS.Math.Content.1.OA.A.1',
        standardItemShortCode: '1.OA.A.1',
        totalExposure: 8,
        totalSchools: 2,
        'Highly Proficient': {
            countAndPercentage: '2 (100%)',
            percentageSchoolsPerformance: 100,
            totalSchoolsPerformance: 2,
        },
        Proficient: {
            countAndPercentage: '1 (50%)',
            percentageSchoolsPerformance: 50,
            totalSchoolsPerformance: 1,
        },
        'Partially Proficient': {
            countAndPercentage: '2 (100%)',
            percentageSchoolsPerformance: 100,
            totalSchoolsPerformance: 1,
        },
        'Not Yet Proficient': {
            countAndPercentage: '2 (100%)',
            percentageSchoolsPerformance: 100,
            totalSchoolsPerformance: 2,
        },
    }),
        data);
}
function mockStudentDistributionAvr(data) {
    if (data === void 0) { data = {}; }
    return new student_distribution_avr_model_1.StudentDistributionAvr((0, merge_1.default)({
        schoolId: '',
        schoolName: '',
        score: 0,
        maxScore: 0,
        percentage: 0,
        scoreCore: 0,
        maxScoreCore: 0,
        percentageCore: 0,
        'Highly Proficient': {
            percentageStudents: 0,
            totalStudents: 0,
        },
        Proficient: {
            percentageStudents: 0,
            totalStudents: 0,
        },
        'Partially Proficient': {
            percentageStudents: 0,
            totalStudents: 0,
        },
        'Not Yet Proficient': {
            percentageStudents: 0,
            totalStudents: 0,
        },
    }, data));
}
function mockStudentDistributionClassAvr(data) {
    if (data === void 0) { data = {}; }
    return new student_distribution_avr_model_1.StudentDistributionAvr((0, merge_1.default)({
        classId: 'any-id',
        className: 'Class001',
        maxScore: 3,
        percentage: 63,
        schoolId: 'any-school-id',
        schoolName: 'WWSChoolOne',
        score: 1.9,
        teacherEmail: 'teacher01_dev@mailinator.com',
        teacherFirstName: 'Teacher01',
        teacherLastName: 'Dev',
        totalClassStudents: 1,
        'Highly Proficient': {
            percentageStudents: 0,
            totalStudents: 0,
        },
        Proficient: {
            percentageStudents: 0,
            totalStudents: 0,
        },
        'Partially Proficient': {
            percentageStudents: 0,
            totalStudents: 0,
        },
        'Not Yet Proficient': {
            percentageStudents: 0,
            totalStudents: 0,
        },
    }, data));
}
function mockScoreByItemClassAvr(data) {
    if (data === void 0) { data = {}; }
    return new reports_1.ScoreByItemClassAvr((0, merge_1.default)({
        classId: '1ddb108b-0599-4cb3-bd52-8a5da3bdd85f',
        className: 'Class001',
        items: [
            {
                itemExternalId: 'GREA_9850',
                itemScore: 0.48,
                itemMaxScore: 1,
                itemOrder: 1,
                itemPercentage: 0.48,
            },
        ],
        maxScore: 3,
        percentage: 43,
        schoolId: '61aeb04c-c4fb-448f-83ab-cdef94d1366c',
        schoolName: 'WWSChoolOne',
        score: 1.3,
        teacherEmail: 'teacher01_dev@mailinator.com',
        teacherFirstName: 'Teacher01',
        teacherLastName: 'Dev',
        totalClassStudents: 16,
    }, data));
}
function mockAverageSummaryAvr(data) {
    if (data === void 0) { data = {}; }
    return new average_summary_avr_model_1.AverageSummaryAvr((0, merge_1.default)({
        score: 12,
        maxScore: 20,
        percentage: 60,
        schoolCount: 10,
        studentCount: 40,
        teacherCount: 15,
        classCount: 15,
    }, data));
}
function mockScoreRawItemClass(data) {
    if (data === void 0) { data = {}; }
    return new reports_1.ScoreRawItemClass((0, merge_1.default)({
        itemExternalId: 'any-item-external-id',
        itemScore: 2,
        itemMaxScore: 5,
        itemPercentage: 40,
        itemOrder: 2,
        itemType: 'core',
    }, data));
}
function mockScoreRawItemAvr(data) {
    if (data === void 0) { data = {}; }
    return new reports_1.ScoreRawItem((0, merge_1.default)({
        itemExternalId: 'any-item-external-id',
        itemScore: 2,
        itemMaxScore: 5,
        itemPercentage: 40,
        itemOrder: 1,
        itemType: 'core',
    }, data));
}
function mockFindScoreByItemAvr(data) {
    if (data === void 0) { data = {}; }
    return new reports_1.ScoreByItemAvr((0, merge_1.default)({
        schoolId: 'any-school-id',
        schoolName: 'any-school-name',
        score: 6,
        maxScore: 10,
        percentage: 60,
        items: [mockScoreRawItemAvr({ itemExternalId: 'any-item-external-id' })],
    }, data));
}
function mockFindScoreByItemClassAvr(data) {
    if (data === void 0) { data = {}; }
    return new reports_1.ScoreByItemClassAvr((0, merge_1.default)({
        classId: 'any-class-id',
        class_name: 'class 1',
        teacherCount: 128,
        teacher_name: 'john-doe',
        schoolId: 'any-school-id',
        school_name: 'klingfurt',
        studentCount: 610,
        score: 4,
        maxScore: 10,
        percentage: 50,
        scoreCore: 4,
        maxScoreCore: 10,
        percentageCore: 50,
        items: [
            mockScoreRawItemAvr({
                itemExternalId: 'any-item-external-id',
                itemScore: 2,
                itemMaxScore: 5,
                itemPercentage: 40,
                itemOrder: 1,
                itemType: 'core',
            }),
        ],
    }, data));
}
function mockStudentItemPerformance(data) {
    if (data === void 0) { data = {}; }
    return new student_item_performance_model_1.StudentItemPerformance((0, merge_1.default)({
        attemptId: 'attempt 1',
        assigneeId: 'assignee 1',
        itemExternalId: 'GREA_9850',
        score: 0,
        maxScore: 1,
        externalQuestionId: 'fb3a4f80-931e-46f8-aff1-a1049dbc5091',
    }, data));
}
function mockLicensesEM2(data) {
    if (data === void 0) { data = {}; }
    return [
        new license_model_1.License((0, merge_1.default)({
            product: {
                id: constants_1.ProductId.Benchmark,
            },
            curriculum: {
                id: constants_1.CurriculumId.EurekaMath2,
            },
        }, data)),
        new license_model_1.License((0, merge_1.default)({
            product: {
                id: constants_1.ProductId.Equip,
            },
            curriculum: {
                id: constants_1.CurriculumId.EurekaMath2,
            },
        }, data)),
    ];
}
function mockItemCustomRubric(data) {
    if (data === void 0) { data = {}; }
    return new __2.ItemCustomRubric((0, merge_1.default)({
        externalItemId: 'ASAU_Automation_item',
        externalQuestionId: '03c2cbeb-0dc2-4b26-8cc8-bbaa9dd6095b',
        customRubric: mockCustomRubric(),
    }, data));
}
function mockCustomRubric(data) {
    if (data === void 0) { data = {}; }
    return new __2.CustomRubric((0, merge_1.default)({
        id: '043451da-95e9-46c7-8d5c-51527553b358',
        name: 'ASAU-Automation-2025-02-05-NzTRP',
        curriculum: 'al',
        grade: 'al.gk',
        type: 'single-point',
        module: 'al.gk.m3',
        rubric: mockRubric(),
        status: 'draft',
        scoringType: 'proficiency',
    }, data));
}
function mockRubric(data) {
    if (data === void 0) { data = {}; }
    return new __2.Rubric((0, merge_1.default)({
        ratings: [
            mockRating(),
            mockRating({
                id: '48f74671-f9f3-451d-b9b5-a44c87c4dac1',
                proficiency: 'developing',
                maxScorePercentageValue: 50,
            }),
            mockRating({
                id: '48f74671-f9f3-451d-b9b5-a44c87c4dac2',
                proficiency: 'onTarget',
                maxScorePercentageValue: 90,
            }),
            mockRating({
                id: '48f74671-f9f3-451d-b9b5-a44c87c4dac3',
                proficiency: 'advanced',
                maxScorePercentageValue: 100,
            }),
            mockRating({
                id: '48f74671-f9f3-451d-b9b5-a44c87c4dac5',
                proficiency: 'unanswered',
                maxScorePercentageValue: 0,
            }),
        ],
        categories: [mockCategory()],
    }, data));
}
function mockCategory(data) {
    if (data === void 0) { data = {}; }
    return new __2.Category((0, merge_1.default)({
        id: '9e93353e-e531-4e99-b1af-c6cc7fa536f9',
        name: 'Knowledge',
        weight: 20,
        default: true,
        criteria: [mockCriterion()],
    }, data));
}
function mockCriterion(data) {
    if (data === void 0) { data = {}; }
    return new __2.Criterion((0, merge_1.default)({
        id: '14511994-e048-4592-b945-bd0597c7ae3c',
        standards: [],
        description: {
            onTarget: 'Automation description2025-02-05',
        },
        score: {
            notYetDemonstrated: 0.03,
            developing: 0.09,
            onTarget: 0.07,
            advanced: 0.07,
            unanswered: 0,
        },
    }, data));
}
function mockRating(data) {
    if (data === void 0) { data = {}; }
    return new __2.Rating((0, merge_1.default)({
        id: '48f74671-f9f3-451d-b9b5-a44c87c4dac4',
        description: '',
        proficiency: 'notYetDemonstrated',
        maxScorePercentageValue: 28,
    }, data));
}
